export default {
  getAvailableOrganizations(state) {
    return state.availableOrganizations
  },
  getUsers(state) {
    return state.users
  },
  getCurrentOrganization(state) {
    return state.currentOrganization
  },
  getPersonalManagerContacts(state) {
    return state.personal_manager
  },
  getSupport(state) {
    return state.support
  },
  changeOrganisation(state) {
    return state.changeOrganisation 
  },
  getAvailableOrganizationsForCurrently(state) {
    return state.availableOrganizationsForCurrently
  },
}